import axios from "axios";
import { BaseStorage, removeStorage } from "./utils";
axios.defaults.retry = 3;
axios.defaults.retryDelay = 50;
axios.defaults.timeout = 30000;
/*是否有请求正在刷新token*/
let isRefreshing = true;
/*被挂起的请求数组*/
let subscribers = [];

function onAccessTokenFetched() {
  subscribers.forEach((callback) => {
    callback();
  });
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}
function InnerPost(params) {
  let data1 = BaseStorage();
  let t = params.split("&").splice(2);
  let data = `${t.join("&")}user_id=${localStorage.getItem(
    "user_id"
  )}&token=${localStorage.getItem("token")}`;
  return axios({
    method: "post",
    url: `${base}`,
    data: data,
  });
}
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    console.log("8888888888888888888");
    return Promise.resolve(err);
  }
);
axios.interceptors.response.use(
  (data) => {
    if (data.status && data.status == 200 && data.data.status == "error") {
      return;
    }
    var t = data.data.ret;
    if (t == 410) {
      // removeStorage();
      if (isRefreshing) {
        axios({
          method: "post",
          url: `${base}`,
          data: {
            service: "App.User.LoginByOpenId",
            openid: localStorage.getItem("openid"),
            unionid: localStorage.getItem("unionid")
              ? localStorage.getItem("unionid")
              : "",
          },
          transformRequest: [
            function(data) {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }).then((res) => {
          if (res.data.ret == 200) {
            var data = res.data.data;
            localStorage.setItem("nickname", data.nickname);
            localStorage.setItem("token", data.token);
            localStorage.setItem("user_id", data.user_id);
            localStorage.setItem("avatar", data.avatar);

            onAccessTokenFetched();
            isRefreshing = true;
          } else {
            // resolve(false);
          }
        });
      }

      isRefreshing = false;
      // console.log(data.config)
      let retry = new Promise((resolve) => {
        /*(token) => {...}这个函数就是回调函数*/
        // console.log(data.config.headers)
        data.config.headers = {
          "Content-Type": "application/x-www-form-urlencoded",
        };
        addSubscriber(() => {
          resolve(InnerPost(data.config.data));
          // resolve(axios(data.config))
        });
      });
      return retry;
    } else {
      return data;
    }
  },
  (err) => {
    Promise.resolve(err);
    if (
      err.code === "ECONNABORTED" &&
      err.message.indexOf("timeout") !== -1
    ) {
      // alert("链接超时");
    }
  }
);

let base = apiConfig().ApiUrl;
export const postRequest = (params) => {
  let data1 = BaseStorage();
  let obj = Object.assign(data1, params);
  // client: `WX:openid:${localStorage.getItem("openid")}`
  obj.client = `WX:${localStorage.getItem("openid")}:2.12`;
  return axios({
    method: "post",
    url: `${base}`,
    data: obj,

    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
export const uploadFileRequest = (params, config) => {
  return axios({
    method: "post",
    url: `${base}`,
    data: params,
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const putRequest = (params) => {
  return axios({
    method: "put",
    url: `${base}`,
    data: params,
    transformRequest: [
      function(data) {
        let ret = "";
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
